<template>
  <section class="py-12">
    <div class="container-wrap">
      <h2 class="text-h1 mb-6">{{ sectionData.name }}</h2>
      <ul class="column-421">
        <li v-for="item in sectionData.subSections" :key="hash(item)">
          <div class="flex tablet:block">
            <TheProductIcon
              v-if="item.imageUrl"
              class="h-14 w-14 tablet:h-20 tablet:w-20"
              :src="item.imageUrl"
              :alt="item.imageAlt || item.name || ''"
              :has-border="false"
              :has-shadow="false"
            />
            <div class="grow basis-0 pl-3 tablet:py-3 tablet:pl-0">
              <h3 class="text-h4 mb-1">{{ item.name }}</h3>
              <p class="text-base text-gray-600">{{ item.description }}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ISection } from '@/assets/types/api/Pages';

  interface IProps {
    sectionData: ISection;
  }

  withDefaults(defineProps<IProps>(), {
    sectionData: () => ({
      code: null,
      name: null,
      description: null,
      type: 1,
      imageUrl: null,
      imageAlt: null,
      link: null,
      align: null,
      theme: null,
      subSections: [],
    }),
  });
</script>
